var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('generated-form',{ref:"generatedForm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }